import { useParams } from 'react-router-dom';
import { ResolvedComponent } from '../../../../routing/ResolvedComponent';
import { EditDestinationInner } from '../../../../destinations/EditDestination/EditDestination';
import { PipelineAPI } from '../../../api/PipelineAPI';
import { IntegrationFactory } from '../../../factories/integrationFactory';

export function PipelineEditDestination() {
  const { id } = useParams();

  const destinationResolver = () =>
    PipelineAPI.getIntegration(Number(id!)).then(res => IntegrationFactory(res.data).destination);

  return (
    <ResolvedComponent
      Component={EditDestinationInner}
      componentProps={{
        cancelUrl: '../job-history'
      }}
      resolve={{
        destination: destinationResolver
      }}
    />
  );
}
